import styled from "styled-components";

const Wrapper = styled.div`
  background-color: var(--primary-color);
  padding: 30px 0 10px;
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .icon-container {
      display: flex;
      gap: 20px;

      .icon {
        font-size: 25px;
        color: #f9f9f9;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        &:hover {
          color: var(--secondary-color);
        }
      }
    }

    .navbar {
      color: #f9f9f9;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 20px;
      cursor: pointer;
      margin: 30px 0 25px;

      li {
        transition: all 0.2s ease-in-out;

        &:hover {
          color: var(--secondary-color);
        }
      }
    }

    .contact-info {
      text-align: center;
      margin: 20px 0;
      display: flex;
      flex-direction: column;
      gap: 10px;

      p {
        font-size: 0.9rem;
        color: rgba(255,255,255,0.7);
        letter-spacing: 2px;
        margin: 0;
        text-transform: uppercase;
        
        a {
          color: white;
          font-weight: 500;
          text-decoration: none;
          margin-left: 10px;
          letter-spacing: 0.5px;
          transition: var(--transition);
          
          &:hover {
            color: var(--secondary-color);
          }
        }
      }
    }

    p {
      color: rgba(255,255,255,0.5); /* Muted copyright text */
      font-size: 0.9rem;
      letter-spacing: 0.8px;
      word-wrap: break-word;
      text-align: center;
      margin-top: 10px;

      @media (max-width: 500px) {
        font-size: 0.8rem;
      }
    }
  }
`;

export default Wrapper;
